// src/components/SpotListModal.js
import { useTranslation } from 'react-i18next';
import SpotItem from './SpotItem';
import '../styles/SpotListModal.css';

export default function SpotListModal({ isOpen, onClose, spots, onSpotClick }) {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  const handleSpotItemClick = (spot) => {
    onClose?.();
    onSpotClick?.(spot);
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="spot-list-modal">
        <div className="spot-list-content">
          {spots.map((spot) => {
            const isStamp = spot.category === 'Stamp';

            const accessory = isStamp ? (
              <img
                src="/images/stamp/stampget-icon.svg" // 固定画像
                alt="stamp"
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: '50%',
                  objectFit: 'cover',
                  boxShadow: '0 2px 6px rgba(0,0,0,.18)',
                  border: '2px solid #fff',
                  background: '#fff',
                }}
                onError={(e) => {
                  e.currentTarget.src = '/images/default-stamp.png';
                }}
              />
            ) : null;

            return (
              <SpotItem
                key={spot.id}
                spot={spot}
                onClick={() => handleSpotItemClick(spot)}
                rightAccessory={accessory}
              />
            );
          })}
        </div>

        <button className="close-button" onClick={onClose}>
          {t('map.buttons.close', '閉じる')}
        </button>
      </div>
    </div>
  );
}
